//Force encoding -> _Íì_ 
exports.getSlabs = function() {
	return[
		{	"id" : 1
			,"name" : "Losa de concreto armado de 12cm de espesor con acabados"
			,"link" : ""
			,"r_value" : 1.9
			,"u_value" : 2.9824
			,"thermal_resistance" : 0.3353
			,"complies_2001" : "No"
		},
		{	"id" : 2
			,"name" : "Losa de concreto armado de 12cm de espesor"
			,"link" : ""
			,"r_value" : 1.689232
			,"u_value" : 3.36247478143914
			,"thermal_resistance" : 0.2974
			,"complies_2001" : "No"
		},
		{	"id" : 3
			,"name" : "Vigueta y bovedilla de cemento arena con acabados"
			,"link" : ""
			,"r_value" : 1.904504
			,"u_value" : 2.98240381747689
			,"thermal_resistance" : 0.3353
			,"complies_2001" : "No"
		},
		{	"id" : 4
			,"name" : "Vigueta y bovedilla de barro \"A\" de 10cm + 5cm de capa de compresión y placa de 3cm de poliestireno al interior con acabados"
			,"link" : "https://ladrilleramecanizada.com/producto/losa-aligerada-de-barroblock"
			,"r_value" : 8.46
			,"u_value" : 0.671
			,"thermal_resistance" : 1.4904
			,"complies_2001" : "Si"
		},
		{	"id" : 5
			,"name" : "Vigueta y bovedilla de barro rellena con poliestireno (EPS) de 12cm + 5cm de capa de compresión. sin acabados"
			,"link" : "https://ladrilleramecanizada.com/producto/losa-aligerada-de-barroblock"
			,"r_value" : 8.89
			,"u_value" : 0.6387
			,"thermal_resistance" : 1.5658
			,"complies_2001" : "Si"
		},
		{	"id" : 6
			,"name" : "Vigueta y bovedilla de barro rellena con poliestireno (EPS) de 14cm + 5cm de capa de compresión. sin acabados"
			,"link" : "https://ladrilleramecanizada.com/producto/losa-aligerada-de-barroblock"
			,"r_value" : 9.66
			,"u_value" : 0.5877
			,"thermal_resistance" : 1.7016
			,"complies_2001" : "Si"
		},
		{	"id" : 7
			,"name" : "Vigueta y bovedilla de barro rellena con poliestireno (EPS) de 20cm + 5cm de capa de compresión. sin acabados"
			,"link" : "https://ladrilleramecanizada.com/producto/losa-aligerada-de-barroblock"
			,"r_value" : 11.39
			,"u_value" : 0.4986
			,"thermal_resistance" : 2.0056
			,"complies_2001" : "Si"
		},
		{	"id" : 8
			,"name" : "Vigueta y bovedilla de barro rellena de poliestireno de 10cm + 5cm de capa de compresión con acabados "
			,"link" : "https://ladrilleramecanizada.com/producto/losa-aligerada-de-barroblock"
			,"r_value" : 8
			,"u_value" : 0.7129
			,"thermal_resistance" : 1.40277
			,"complies_2001" : "Si"
		},
		{	"id" : 9
			,"name" : "Lámina Pintro C. 26"
			,"link" : ""
			,"r_value" : 1.297312
			,"u_value" : 4.37828371278459
			,"thermal_resistance" : 0.2284
			,"complies_2001" : "No"
		},
		{	"id" : 10
			,"name" : "Lámina Galvanizada C. 26"
			,"link" : ""
			,"r_value" : 1.297312
			,"u_value" : 4.37828371278459
			,"thermal_resistance" : 0.2284
			,"complies_2001" : "No"
		},
		{	"id" : 11
			,"name" : "Tecnopanel techo 1.0cm"
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 2.88792913752914
			,"u_value" : 1.96680726205758
			,"thermal_resistance" : 0.508438228438229
			,"complies_2001" : "No"
		},
		{	"id" : 12
			,"name" : "Tecnopanel techo 1.25\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 6.313888
			,"u_value" : 0.899604174163368
			,"thermal_resistance" : 1.1116
			,"complies_2001" : "No"
		},
		{	"id" : 13
			,"name" : "Tecnopanel techo 1.5\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 7.316976
			,"u_value" : 0.776276975624903
			,"thermal_resistance" : 1.2882
			,"complies_2001" : "No"
		},
		{	"id" : 14
			,"name" : "Tecnopanel techo 2\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 9.32372
			,"u_value" : 0.609198903441974
			,"thermal_resistance" : 1.6415
			,"complies_2001" : "Si"
		},
		{	"id" : 15
			,"name" : "Tecnopanel techo 2.5\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 11.329896
			,"u_value" : 0.501328520579536
			,"thermal_resistance" : 1.9947
			,"complies_2001" : "Si"
		},
		{	"id" : 16
			,"name" : "Tecnopanel techo 3\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 13.33664
			,"u_value" : 0.425894378194208
			,"thermal_resistance" : 2.348
			,"complies_2001" : "Si"
		},
		{	"id" : 17
			,"name" : "Tecnopanel techo 4\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 17.34956
			,"u_value" : 0.327385824193812
			,"thermal_resistance" : 3.0545
			,"complies_2001" : "Si"
		},
		{	"id" : 18
			,"name" : "Tecnopanel techo 5\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 21.363048
			,"u_value" : 0.265879662864587
			,"thermal_resistance" : 3.7611
			,"complies_2001" : "Si"
		},
		{	"id" : 19
			,"name" : "Tecnopanel techo 6\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 25.375968
			,"u_value" : 0.22383382576775
			,"thermal_resistance" : 4.4676
			,"complies_2001" : "Si"
		},
		{	"id" : 20
			,"name" : "Tecnopanel techo 7\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 29.389456
			,"u_value" : 0.193266591936918
			,"thermal_resistance" : 5.1742
			,"complies_2001" : "Si"
		},
		{	"id" : 21
			,"name" : "Tecnopanel techo 8\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 33.402376
			,"u_value" : 0.170047783427143
			,"thermal_resistance" : 5.8807
			,"complies_2001" : "Si"
		},
		{	"id" : 22
			,"name" : "Tecnopanel techo 9\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 37.415296
			,"u_value" : 0.151809570075298
			,"thermal_resistance" : 6.5872
			,"complies_2001" : "Si"
		},
		{	"id" : 23
			,"name" : "Tecnopanel techo 10\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 41.428784
			,"u_value" : 0.137102744796951
			,"thermal_resistance" : 7.2938
			,"complies_2001" : "Si"
		},
		{	"id" : 24
			,"name" : "Panel Contec AAC 3.5 10cm"
			,"link" : ""
			,"r_value" : 5.35467199467199
			,"u_value" : 1.06075591663723
			,"thermal_resistance" : 0.942723942723943
			,"complies_2001" : "No"
		},
		{	"id" : 25
			,"name" : "Panel Contec AAC 3.5 12.5cm"
			,"link" : ""
			,"r_value" : 6.36895770895771
			,"u_value" : 0.891825673769396
			,"thermal_resistance" : 1.12129537129537
			,"complies_2001" : "No"
		},
		{	"id" : 26
			,"name" : "Panel Contec AAC 3.5 15cm"
			,"link" : ""
			,"r_value" : 7.38324342324342
			,"u_value" : 0.769309593954144
			,"thermal_resistance" : 1.2998667998668
			,"complies_2001" : "No"
		},
		{	"id" : 27
			,"name" : "Panel Contec AAC 3.5 17.5cm"
			,"link" : ""
			,"r_value" : 8.39752913752914
			,"u_value" : 0.676389436342136
			,"thermal_resistance" : 1.47843822843823
			,"complies_2001" : "Si"
		},
		{	"id" : 28
			,"name" : "Panel Contec AAC 3.5 20cm"
			,"link" : ""
			,"r_value" : 9.41181485181485
			,"u_value" : 0.603496784565916
			,"thermal_resistance" : 1.65700965700966
			,"complies_2001" : "Si"
		},
		{	"id" : 29
			,"name" : "Panel Contec AAC 3.5 25cm"
			,"link" : ""
			,"r_value" : 11.4403862803863
			,"u_value" : 0.496486732247665
			,"thermal_resistance" : 2.01415251415251
			,"complies_2001" : "Si"
		},
		{	"id" : 30
			,"name" : "Panel Contec AAC 3.5 30cm"
			,"link" : ""
			,"r_value" : 13.4689577089577
			,"u_value" : 0.421710433927819
			,"thermal_resistance" : 2.37129537129537
			,"complies_2001" : "Si"
		},
		{	"id" : 31
			,"name" : "Panel Contec AAC 5.0 10cm"
			,"link" : ""
			,"r_value" : 4.84752913752914
			,"u_value" : 1.17173096620007
			,"thermal_resistance" : 0.853438228438228
			,"complies_2001" : "No"
		},
		{	"id" : 32
			,"name" : "Panel Contec AAC 5.0 12.5cm"
			,"link" : ""
			,"r_value" : 5.73502913752914
			,"u_value" : 0.990404732703268
			,"thermal_resistance" : 1.00968822843823
			,"complies_2001" : "No"
		},
		{	"id" : 33
			,"name" : "Panel Contec AAC 5.0 15cm"
			,"link" : ""
			,"r_value" : 6.62252913752914
			,"u_value" : 0.857678370611021
			,"thermal_resistance" : 1.16593822843823
			,"complies_2001" : "No"
		},
		{	"id" : 34
			,"name" : "Panel Contec AAC 5.0 17.5cm"
			,"link" : ""
			,"r_value" : 7.51002913752914
			,"u_value" : 0.756321965731916
			,"thermal_resistance" : 1.32218822843823
			,"complies_2001" : "No"
		},
		{	"id" : 35
			,"name" : "Panel Contec AAC 5.0 20cm"
			,"link" : ""
			,"r_value" : 8.39752913752914
			,"u_value" : 0.676389436342136
			,"thermal_resistance" : 1.47843822843823
			,"complies_2001" : "Si"
		},
		{	"id" : 36
			,"name" : "Panel Contec AAC 5.0 25cm"
			,"link" : ""
			,"r_value" : 10.1725291375291
			,"u_value" : 0.558366550069145
			,"thermal_resistance" : 1.79093822843823
			,"complies_2001" : "Si"
		},
		{	"id" : 37
			,"name" : "Panel Contec AAC 5.0 30cm"
			,"link" : ""
			,"r_value" : 11.9475291375291
			,"u_value" : 0.475412106940019
			,"thermal_resistance" : 2.10343822843823
			,"complies_2001" : "Si"
		},
		{	"id" : 38
			,"name" : "Vigueta y bovedilla de poliestireno estándar 12+5"
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 9.01132
			,"u_value" : 0.630318310746927
			,"thermal_resistance" : 1.5865
			,"complies_2001" : "Si"
		},
		{	"id" : 39
			,"name" : "Vigueta y bovedilla de poliestireno estándar 14+5"
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 10.20412
			,"u_value" : 0.55663790704147
			,"thermal_resistance" : 1.7965
			,"complies_2001" : "Si"
		},
		{	"id" : 40
			,"name" : "Vigueta y bovedilla de poliestireno envolvente 10+1\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 13.55532
			,"u_value" : 0.419023674837628
			,"thermal_resistance" : 2.3865
			,"complies_2001" : "Si"
		},
		{	"id" : 41
			,"name" : "Vigueta y bovedilla de poliestireno envolvente 12+1\""
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 15.124704
			,"u_value" : 0.375544539582394
			,"thermal_resistance" : 2.6628
			,"complies_2001" : "Si"
		},
		{	"id" : 42
			,"name" : "Tecnoplaca Integral"
			,"link" : "htps://tecnopol.mx"
			,"r_value" : 11.307744
			,"u_value" : 0.502310628892907
			,"thermal_resistance" : 1.9908
			,"complies_2001" : "Si"
		}
	];
}
